import type {
  PaymentCollectionStatus,
  PaymentDepositRefundStatus,
  PaymentSettlementStatus,
  PaymentTab,
} from '@/types/payment.types';
import type { PayoutMethod } from '@/types/payout.types';

export const PAGE_SIZE = 20;
export const PAYMENTS_QUERY_KEY = 'payments';

export const PAYMENT_TABS: { key: PaymentTab; label: string }[] = [
  { key: 'awaiting', label: 'Awaiting' },
  { key: 'submitted', label: 'Submitted' },
  { key: 'verified', label: 'Verified' },
  { key: 'to_settle', label: 'To settle' },
  { key: 'settled', label: 'Settled' },
  { key: 'disputed', label: 'Disputed' },
];

export const COLLECTION_STATUS_LABEL: Record<PaymentCollectionStatus, { label: string; tone: string }> = {
  awaiting_payment: { label: 'Awaiting payment', tone: 'bg-amber-100 text-amber-700' },
  payment_submitted: { label: 'Submitted', tone: 'bg-brand-50 text-brand-600' },
  verified: { label: 'Verified', tone: 'bg-emerald-100 text-emerald-700' },
  rejected: { label: 'Rejected', tone: 'bg-red-100 text-red-700' },
  refunded: { label: 'Refunded', tone: 'bg-[var(--color-surface-muted)] text-[var(--color-ink-muted)]' },
};

export const SETTLEMENT_STATUS_LABEL: Record<PaymentSettlementStatus, { label: string; tone: string }> = {
  pending: { label: 'Pending', tone: 'bg-[var(--color-surface-muted)] text-[var(--color-ink-muted)]' },
  paid: { label: 'Paid — awaiting owner', tone: 'bg-brand-50 text-brand-600' },
  owner_confirmed: { label: '✓ Owner confirmed', tone: 'bg-emerald-100 text-emerald-700' },
  disputed: { label: 'Disputed', tone: 'bg-red-100 text-red-700' },
};

export const DEPOSIT_STATUS_LABEL: Record<PaymentDepositRefundStatus, { label: string; tone: string }> = {
  pending: { label: 'Deposit pending', tone: 'bg-[var(--color-surface-muted)] text-[var(--color-ink-muted)]' },
  refunded: { label: 'Refunded — awaiting borrower', tone: 'bg-brand-50 text-brand-600' },
  borrower_confirmed: { label: '✓ Borrower confirmed', tone: 'bg-emerald-100 text-emerald-700' },
  forfeited: { label: 'Deposit forfeited', tone: 'bg-red-100 text-red-700' },
};

/** Label for a party's payout rail in the detail drawer. */
export const PAYOUT_METHOD_LABEL: Record<PayoutMethod, string> = {
  upi: 'UPI',
  bank: 'Bank transfer',
};

export const PAYOUT_MISSING_OWNER =
  'This owner has not added payout details, so there is nowhere to send the money. Remind them, then settle once they have.';
export const PAYOUT_MISSING_BORROWER =
  'This borrower has not added payout details and gave no UPI ID with their proof. Remind them before refunding the deposit.';
export const PAYOUT_REMIND_LABEL = 'Ask for payout details';
